import Typography from '@mui/material/Typography';
import styled from '@mui/material/styles/styled';

export const StyledTypography = styled(Typography)`
	font-size: 0.625rem;
	font-weight: 600;
	text-align: center;
	color: ${({theme}) => theme.palette.common.black};
`;
